import App from './App';



dn.one('mount', () => {
  new Vue({
    render: h => h(App),
    el: '#pg-app',
    parent: dn,
  });
});



// WEBPACK FOOTER //
// ./src/js/sokuhou/yosou/index.js